<template>
  <div>
    <el-form-item label="表单栅格">
          <el-input-number v-model="data.span"
                          controls-position="right"
                          placeholder="表单栅格"
                          :min="6"
                          :max="24"></el-input-number>
        </el-form-item>
    <el-tabs v-model="remote" stretch>
      <el-tab-pane label="静态二维码" name="0" class="tab">
        <el-form-item label="网址">
          <el-input v-model="data.url" placeholder="网址"></el-input>
        </el-form-item>
        <el-form-item label="logo">
          <el-input v-model="data.logoImg"
                    placeholder="logo"></el-input>
        </el-form-item>
        <el-form-item label="提示语言">
          <el-input v-model="data.tip"
                    placeholder="提示语言"></el-input>
        </el-form-item>
      </el-tab-pane>
      <el-tab-pane label="动态二维码" name="1" class="tab">
        <el-form-item label="动态地址">
          <el-input v-model="data.qrurl" placeholder="网址"></el-input>
        </el-form-item>
        <el-form-item label="刷新频率(秒)">
          <el-input v-model="data.rate" placeholder="主动刷新频率"></el-input>
        </el-form-item>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  props: ['data', 'widgetForm'],
  data() {
    return {
      remote: this.data.remote ? '1' : '0'
    }
  },
  watch: {
    remote(v) {
      this.data.remote = !!(v == 1)
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(this.remote)
    }
  }
}
</script>

<style lang="scss" scoped>
.tab {
  padding: 20px 0;
}
</style>
